<template>
  <div class="about">
    <div class="about-child" style="margin-bottom: 96px;">
      <van-image class="top-banner" src="https://cloud.wisewater.cn/group1/M00/08/A8/rBAABV56-gqAWanhAARtGbphb6U111.png" />
      <div class="grid-parent-block">
        <div class="about-doc-name">我的业务</div>
        <van-grid class="business-container" :column-num="3">
          <!-- <van-grid-item v-for="(item, index) in items" :key="item.title" :text="item.title" :badge="item.badge" @click="goPage(index)">
            <van-icon class="iconfont" class-prefix="icon" slot="icon" v-if="index == 0" :name="item.icon"></van-icon>
            <van-icon class="iconfont" class-prefix="icon" slot="icon" v-if="index == 1" :name="item.icon"></van-icon>
            <van-icon class="iconfont" class-prefix="icon" slot="icon" v-if="index == 2" :name="item.icon"></van-icon>
          </van-grid-item> -->
          <van-grid-item text="全部业务" @click="goScheduleList(0)">
            <van-icon class="iconfont" class-prefix="icon" slot="icon" name="quanbu"></van-icon>
          </van-grid-item>
          <van-grid-item text="已完成" @click="goScheduleList(1)">
            <van-icon class="iconfont" class-prefix="icon" slot="icon" name="yiwancheng"></van-icon>
          </van-grid-item>
          <van-grid-item text="待处理" :badge="badge" @click="goScheduleList(2)">
            <van-icon class="iconfont" class-prefix="icon" slot="icon" name="daichuli"></van-icon>
          </van-grid-item>
        </van-grid>
      </div>
      <!-- <van-notice-bar @click="announce" scrollable mode="link" left-icon="volume-o" text="2021年4月19日青秀区高坡岭路停水通知" /> -->
      <div class="fnc-container">
        <div class="fnc-content" v-for="sub in subMenus" :key="sub.id" @click="goPage(sub)">
          <van-icon v-if="sub.iconType == 1" class="fnc-icon" :color="sub.iconColor" :name="sub.iconUrl" />
          <van-icon v-if="sub.iconType == 2" class="iconfont fnc-icon" class-prefix="icon" :color="sub.iconColor" :name="sub.iconUrl" />
          <van-image v-if="sub.iconType == 3" class="icon-img" slot="icon" :src="filePath + sub.iconUrl" />
          <span class="fnc-text">{{sub.name}}</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
    </div>
    <div class="business-tel">
      <img src="https://business.wisewater.cn/zsy_businesshall/pages/main/image/personal/phone_icon.png" />
      <span>业务热线 {{businessTel}}</span>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { NoticeBar, Image as VanImage, Notify, Grid, GridItem } from 'vant'
import { getMenuUrlReq, getMpReq, getBusCountReq } from '@/api/manage'

Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(NoticeBar)
Vue.use(Notify)
export default {
  data () {
    return {
      businessTel: '',
      items: [{
        icon: 'quanbu',
        title: '全部业务',
        redirect_page: '',
        badge: ''
      }, {
        icon: 'yiwancheng',
        title: '已完成',
        redirect_page: '',
        badge: ''
      }, {
        icon: 'daichuli',
        title: '待处理',
        redirect_page: '',
        badge: 99
      }],
      badge: '',
      subMenus: []
    }
  },
  created () {
    // 获取菜单
    const paramsMenu = {
      location: '22',
      token: this.$cookies.get('token')
    }
    getMenuUrlReq(paramsMenu).then(response => {
      const res = response.data
      if (res.code === 200) {
        this.subMenus = res.data[0].subMenuForms
      }
    })
      .catch((res) => {
        Notify({ type: 'danger', message: '获取菜单列表失败' })
      })

    // 获取业务热线
    const params = {
      token: this.$cookies.get('token')
    }
    getMpReq(params).then(response => {
      const res = response.data
      if (res.code === 200) {
        this.businessTel = res.data.tel
      }
    })
      .catch((res) => {
        Notify({ type: 'danger', message: '获取菜单列表失败' })
      })

    const paramsBus = {
      token: this.$cookies.get('token'),
      openId: this.$cookies.get('openid'),
      type: 2,
    }
    getBusCountReq(paramsBus).then(response => {
      const res = response.data
      console.log(res)
      if (res.code === 200) {
        if (res.data > 0) {
          this.badge = res.data
        }
      }
    })
      .catch((res) => {
        Notify({ type: 'danger', message: '获取菜单列表失败' })
      })
  },
  methods: {
    announce () {
      if (this.del) {

      } else {
        Notify({ type: 'primary', message: '没有更多通知了哦~' })
      }
    },
    goScheduleList (index) {
      this.$router.push({
        name: 'scheduleList',
        params: {
          index: index
        },
        query: {
          token: this.$cookies.get('token')
        }
      })
    },
    goPage (sub) {
      const isSecond = sub.isSecond
      const id = sub.id
      const url = sub.visitUrl
      if (url == null) {

      } else if (url.indexOf('http') !== -1) {
        window.location.href = url
      } else {
        var parentId = ''
        if (isSecond) {
          parentId = id
        }
        this.$router.push({
          path: url,
          query: {
            token: this.$cookies.get('token'),
            parentId: parentId
          }
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
  .van-icon {
    font-size: 24px;
  }
  .top-banner {
    position: relative;
    height: 300px;
    z-index: 1;
  }
  .grid-parent-block {
    position: relative;
    margin: -130px 12px 12px 12px;
    background-color: #FFF;
    border-radius: 8px;
    z-index: 99;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);
  }
  .about-doc-name {
    margin: 0 16px;
    padding: 16px 0;
    color: rgba(8, 8, 8, 0.6);
    font-weight: bold;
    font-size: 15px;
    line-height: 16px;
    background-color: #fff;
    border-bottom: 1px solid #ebedf0;
  }
  /deep/ .van-grid-item__content {
    background: none;
  }
  /deep/ .van-grid-item__text {
    font-size: 13px;
  }
  .van-hairline--top::after {
    border-width: 0;
  }
  /deep/ .van-grid-item__content::after {
    border-width: 0;
  }
  /deep/ .van-info {
    top: 12px;
  }
  .van-notice-bar {
    margin: 0 12px 12px;
  }
  .fnc-container {
    position: relative;
    margin: 0 12px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);
  }
  .fnc-content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin: 0 15px;
    min-height: 50px;
    -webkit-box-pack: justify;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .fnc-content:not(:last-child) {
    border-bottom: 0.5px solid #ddd;
  }
  .fnc-icon {
    margin-right: 15px;
  }
  .fnc-text {
    font-size: 13px;
  }
  .arrow {
    position: absolute;
    top: 0;
    right: 2px;
    bottom: 0;
    display: block;
    margin: auto;
    width: 15px;
    height: 15px;
    color: #8799a3;
    text-align: center;
    font-size: 17px;
    line-height: 15px;
  }
  .business-container, .fnc-container {
    color: #505050;
  }
  .business-tel {
    position: fixed;
    left: 0;
    height: 38px;
    line-height: 32px;
    width: 100%;
    background-color: #19a2fd;
    color: #fff;
    text-align: center;
    box-sizing: content-box;
    bottom: calc(50px + constant( safe-area-inset-bottom));
    bottom: calc(50px + env(safe-area-inset-bottom));
  }
  .business-tel img {
    display: inline-block;
    width: 25px;
    vertical-align: middle;
  }
  .business-tel span {
    margin: 0 10px;
    font-size: 18px;
    font-style: italic;
    font-weight: bold;
    vertical-align: middle;
  }
</style>
